export default function Brand({ subtitle, light = false, onDark = false }) {
  return (
    <span className="flex items-center space-x-3">
      <img
        src="/logo.jpg"
        alt="Dreams Soft Solutions logo"
        className="h-9 w-9 rounded-md object-cover bg-white dark:bg-slate-900"
        data-testid="brand-logo-img"
      />
      <span className="flex flex-col leading-tight">
        <span className={`text-sm font-bold tracking-tight uppercase code-font ${onDark ? "text-white" : "text-slate-900 dark:text-white"}`}>
          Dreams Soft Solutions
        </span>
        {subtitle && (
          <span className={`text-[10px] code-font tracking-widest uppercase ${onDark ? "text-slate-300" : "text-slate-500 dark:text-slate-400"}`}>{subtitle}</span>
        )}
      </span>
    </span>
  );
}
